import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageComponent } from './select-language/select-language.component';
import {
    AlertModule,
    ButtonModule,
    InputModule,
    LinkModule,
    LocalLoaderModule,
    ModalsModule,
    SosAccountStoreModule,
    SosAuthorizationStoreModule,
    SosLoaderModule,
} from '@serviceos-ng/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [SelectLanguageComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalsModule,
        LinkModule,
        InputModule,
        SosAuthorizationStoreModule,
        SosAccountStoreModule,
        ButtonModule,
        AlertModule,
        SosLoaderModule,
        LocalLoaderModule
    ],
    exports: [SelectLanguageComponent],
})
export class SelectLanguageModule {}
